import React from 'react';
import { Route } from 'react-router-dom';
import CountryConfig from 'containers/CountryConfig';
import UploadIngredient from 'containers/Ingredient/Upload';

export default [
  <Route path="/countryconfigs" component={CountryConfig} />,
  <Route exact path="/upload-ingredients" component={UploadIngredient} />,
];
